import { FC } from 'react'
import { Location } from './Location'
import { TimeLocationContainer } from './styles'
import { Time } from './Time'

type TimeLocationProps = {
  // customTop: string
  editTimeLocation?: () => void
}

export const TimeLocation: FC<TimeLocationProps> = ({ editTimeLocation }) => {
  const handleEdit = () => {
    if (editTimeLocation) {
      editTimeLocation?.()
    }
  }

  return (
    <TimeLocationContainer onClick={handleEdit}>
      <Time />
      <Location />
    </TimeLocationContainer>
  )
}
